import { useQuery } from "@tanstack/react-query";

/**
 *
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {string|number} deps.id
 * @param {string} deps.currentLang
 * @param {boolean} [deps.enabled]
 * @param {(args: { id: string, currentLang: string }) => string} [deps.buildUrl]
 */
export function useGetVocabById({
  callApiWithWorker,
  id,
  currentLang,
  enabled = true,
  buildUrl,
}) {
  const normalizedId =
    id === null || id === undefined || id === "" ? null : String(id);

  return useQuery({
    queryKey: ["vocabById", normalizedId, currentLang],
    enabled: Boolean(
      enabled && callApiWithWorker && normalizedId && currentLang,
    ),
    queryFn: async ({ signal }) => {
      const url =
        typeof buildUrl === "function"
          ? buildUrl({ id: normalizedId, currentLang })
          : `/api/vocabularyHub/get/${encodeURIComponent(normalizedId)}?lang=${encodeURIComponent(currentLang)}`;

      const res = await callApiWithWorker(url, { method: "GET", signal });

      const payload =
        typeof res?.body === "string"
          ? JSON.parse(res.body)
          : (res?.data ?? res);

      return payload?.item ?? payload?.data ?? payload;
    },
    staleTime: 10_000,
  });
}
